module.exports = __webpack_public_path__ + "static/media/Space Miner.a3aa562c.jpg";